import React from "react";
import { GAevent } from "../../../../utils/googleAnalyticsHelper";
import styles from "./PdfButton.module.scss";

const PdfButton = ({ product, openPdfModal }) => {
  const { Model, PdfPath } = product;

  const handleClick = () => {
    openPdfModal();
    GAevent("Guest-User", "click", `See More Details Button - ${Model}`);
  };

  return (
    <>
      {PdfPath && (
        <button className={styles.btn} onClick={handleClick}>
          Product Brochure
        </button>
      )}
    </>
  );
};

export { PdfButton };
